module.exports = __webpack_public_path__ + "static/media/gitkraken.36504ce2.svg";